import type { ToggleProps } from '@base-ui/react';

import { Toggle as BaseToggle } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import type { ButtonEmphasis } from '../Button/Button.utils';
import type { IconName } from '../Icon/Icon';

import { buttonStyle, emphasisButtonStyles, iconOnlyButtonStyle } from '../Button/Button.css';
import { Icon } from '../Icon/Icon';

type Props = ToggleProps<string> & {
  'aria-label': string;
  emphasis?: ButtonEmphasis;
  icon: IconName;
  pressedIcon?: IconName;
};

export const Toggle = ({ children, emphasis, icon, pressedIcon, ...delegated }: Props) => {
  const isIconOnly = children === null || children === undefined;
  const defaultEmphasis = isIconOnly ? 'tertiary' : 'primary';

  return (
    <BaseToggle
      {...delegated}
      className={clsxs(
        buttonStyle,
        emphasisButtonStyles[emphasis ?? defaultEmphasis],
        isIconOnly && iconOnlyButtonStyle,
        delegated.className,
      )}
      render={(toggleProps, state) => (
        <button {...toggleProps}>
          <Icon name={state.pressed && pressedIcon ? pressedIcon : icon} size={22} />
          {children}
        </button>
      )}
    />
  );
};
